import { useState } from 'react';

export default function useFinancialTab() {
  const [geraNFSeparada, setGeraNFSeparada] = useState(false);

  return {
    geraNFSeparada,
    setGeraNFSeparada,
  };
}
